import { Drawer } from '@components/common/drawer/drawer';
import FilterIcon from '@components/icons/filter-icon';
import Text from '@components/ui-old/text';
import { useUI } from '@contexts/ui.context';
import FilterSidebar from '@components/shop/filter-sidebar';
//import ListBox from '@components/ui/list-box';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { getDirection } from '@utils/get-direction';
import motionProps from '@components/common/drawer/motion';
import { useCategoriesQuery } from '@framework/category/get-all-categories';
import QuickOrderModal from '@components/product/express-shopping';
import { Button } from "@/components/ui/button";
interface SearchTopBarProps {
  totalItems: number;
}
function slugToTitle(slug: string): string {
  return slug.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}
export default function SearchTopBar({}: SearchTopBarProps) {
  const {
    openFilter,
    displayFilter,
    closeFilter
  } = useUI();
  const {
    t
  } = useTranslation('common');
  const {
    locale,
    query
  } = useRouter();
  const dir = getDirection(locale);
  const contentWrapperCSS = dir === 'ltr' ? {
    left: 0
  } : {
    right: 0
  };
  const {
    data: categoryData
  } = useCategoriesQuery({
    limit: 20
  });
  const getCategoryNameById = (id: string) => {
    const category = categoryData?.categories?.data.find(cat => cat.id.toString() === id);
    return category ? category.name : slugToTitle(id);
  };
  const categoryName = query.category ? getCategoryNameById(query.category as string) : t('text-products');
  return <div className="flex justify-between items-center mb-7" data-sentry-component="SearchTopBar" data-sentry-source-file="top-bar.tsx">
      <Text variant="pageHeading" className="hidden lg:inline-flex pb-1 dark:text-neutral-200" data-sentry-element="Text" data-sentry-source-file="top-bar.tsx">
        {categoryName}
      </Text>
      <div className="flex items-center h-12">
  <Button variant="outline" className="lg:hidden text-sm px-4 py-2 font-semibold  flex items-center transition duration-200 ease-in-out h-full" onClick={openFilter} data-sentry-element="Button" data-sentry-source-file="top-bar.tsx">
    <FilterIcon data-sentry-element="FilterIcon" data-sentry-source-file="top-bar.tsx" />
    <span className="ltr:pl-2.5 rtl:pr-2.5">{t('text-filters')}</span>
  </Button>
  <span className="flex items-center w-full text-sm px-4 py-2 lg:hidden h-full">
    <QuickOrderModal data-sentry-element="QuickOrderModal" data-sentry-source-file="top-bar.tsx" />
  </span>
    </div>

      <div className="flex items-center justify-end">
        <div className="flex-shrink-0 text-body dark:text-neutral-200 text-xs md:text-sm leading-4 ltr:pr-4 rtl:pl-4 ltr:md:mr-6 rtl:md:ml-6 ltr:pl-2 rtl:pr-2 hidden lg:block">
          {/* {totalItems} {t('text-items')} */}
        </div>
        {/* <ListBox
          options={[
            { name: 'text-sorting-options', value: 'options' },
            { name: 'text-newest', value: 'newest' },
            { name: 'text-popularity', value: 'popularity' },
            { name: 'text-price-low-high', value: 'low-high' },
            { name: 'text-price-high-low', value: 'high-low' },
          ]}
         /> */}
      </div>
      <Drawer placement={dir === 'rtl' ? 'right' : 'left'} open={displayFilter} onClose={closeFilter} contentWrapperStyle={contentWrapperCSS} {...motionProps} data-sentry-element="Drawer" data-sentry-source-file="top-bar.tsx">
        <FilterSidebar data-sentry-element="FilterSidebar" data-sentry-source-file="top-bar.tsx" />
      </Drawer>
    </div>;
}